import { SAVEMESSAGE, REMOVEMESSAGE } from './Action-types';

export const setSaveMessage = () => ({
  type: SAVEMESSAGE
});

export const removeSaveMessage = () => ({
  type: REMOVEMESSAGE
});